export default __webpack_public_path__ + "imgs/icon5.png";